import { useRef } from 'react';
import { Authentication } from '../components/Authentication';
import { Script } from '../components/Script';
import { CIAM_REDIRECT_PATH } from '../types';
import { CiamContext, createCiamStore } from './CiamContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CiamProvider = _ref => {
  let {
    autoAuthentication = true,
    brand,
    brandGroup,
    children,
    clientId,
    environment,
    redirectPaths
  } = _ref;
  const store = useRef(createCiamStore({
    autoAuthentication,
    brand,
    brandGroup,
    clientId,
    environment,
    redirectPaths: {
      login: redirectPaths?.login || CIAM_REDIRECT_PATH.LOGIN,
      logout: redirectPaths?.logout || CIAM_REDIRECT_PATH.LOGOUT,
      register: redirectPaths?.register || CIAM_REDIRECT_PATH.REGISTER
    }
  })).current;
  return /*#__PURE__*/_jsxs(CiamContext.Provider, {
    value: store,
    children: [/*#__PURE__*/_jsx(Script, {}), autoAuthentication ? /*#__PURE__*/_jsx(Authentication, {
      silent: true,
      children: children
    }) : children]
  });
};
export default CiamProvider;